import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { formatDecimalNumber } from "../../../utils";

export const DiscountPercentInput = (props) => {
    const { fieldName, range, label, readonly = false, fullWidth=false, formatPercentAsDecimal=false, step } = props;
    const { min, max } = range;
    const { control } = useFormContext();

    return (
        <Controller
            name={fieldName}
            control={control}
            render={({ field: { value = 0, onChange } }) => {
                const formatedValue = formatPercentAsDecimal ? formatDecimalNumber(value, 2) : value
                return <TextField
                    label={label}
                    fullWidth={fullWidth}
                    type="number"
                    value={formatedValue}
                    onChange={(event) => {
                        let newValue = Number(event.target.value);
                        if (Number.isNaN(newValue) || newValue < min) {
                            newValue = min;
                        }
                        if (newValue > max) {
                            newValue = max;
                        }
                        onChange(newValue);
                    }}
                    inputProps={{ min: min, max: max, step:step }}
                    disabled={readonly}
                />
            }}
        />
    );
};
